import * as t from './action_types';
// not sure these are necessary, can we just use selected site or root and then
const INITIAL_STATE = {
    availableAuthSites: [],
    availableAuthSitesLoaded: false,
    authSiteFilters: {},
};

const app = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case t.RESET_APP_DATA:
            return {
                ...INITIAL_STATE,
            };
        case t.SET_AUTH_SITE_LIST:
            return {
                ...state,
                availableAuthSitesLoaded: true,
                availableAuthSites: action.payload.data,
            };
        case t.SET_AUTH_SITE_FILTERS:
            return {
                ...state,
                authSiteFilters: action.payload.filters,
            };
        case t.SET_IS_MOBILE: {
            const isMobile = action.payload.isMobile;
            return {
                ...state,
                isMobile,
            };
        }

        default:
            return state;
    }
};

export default app;
